import { queryOptions } from '@tanstack/react-query';

import { fetchAllTeams, fetchAssociationTeams, fetchTeamsById } from '@apis/teams';

export const getAllTeamsQuery = (params: Parameters<typeof fetchAllTeams>[0]) =>
  queryOptions({
    queryKey: ['teams', params],
    queryFn: ({ signal }) => fetchAllTeams(params, signal),
    placeholderData: [],
  });

export const getTeamsbyIdsQuery = (params: Parameters<typeof fetchTeamsById>[0]) =>
  queryOptions({
    queryKey: ['teamsIds', params],
    queryFn: ({ signal }) => fetchTeamsById(params, signal),
    placeholderData: [],
  });

export const getAssociationTeamsQuery = (params: Parameters<typeof fetchAssociationTeams>[0]) =>
  queryOptions({
    queryKey: ['association-teams', params],
    queryFn: ({ signal }) => fetchAssociationTeams(params, signal),
    enabled: !!params.associationId,
    placeholderData: [],
  });
